/** Labels for the scope catalog's `action` column — purely cosmetic, shown
 * as a small pill next to each scope's key/description. Falls back to a
 * title-cased version of the raw value for any action not listed here, so
 * a new action shipped via migration doesn't need a frontend change to show
 * up (just with a plainer label until this map is updated). */
export const SCOPE_ACTION_LABELS = {
    view: 'View',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    manage: 'Manage',
    enabled: 'Enabled',
    visible: 'Visible',
    reconcile: 'Reconcile',
};

export function formatScopeSectionLabel(section) {
    if (!section) return '';
    return section.charAt(0).toUpperCase() + section.slice(1);
}

export function formatScopeActionLabel(action) {
    if (!action) return '';
    return SCOPE_ACTION_LABELS[action] || formatScopeSectionLabel(action);
}
